// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"5a4f0d7f","369":"bba5fd6a"}[chunkId] + ".chunk.js";
};